import { FILTER_MAPPINGS } from "@/config/filterMappings";
import { buildQueryFromFilters, parseQueryToFilters } from "@/utils/filterNormalization";
import type { ProviderFilters } from "@/features/providers/types/providers.types";

const PROVIDERS_FILTER_MAPPING = FILTER_MAPPINGS.providers;

export const defaultProviderFilters: ProviderFilters = {
  search: "",
  provider_type: "No Filters",
  service_areas: [],
};

export const buildProvidersFilterExpression = (filters: ProviderFilters): string => (
  buildQueryFromFilters(filters, PROVIDERS_FILTER_MAPPING)
);

export const parseProvidersFilterExpression = (
  params: URLSearchParams,
): Partial<ProviderFilters> => (
  parseQueryToFilters<ProviderFilters>(params, PROVIDERS_FILTER_MAPPING)
);
